class BoldCustomAddToCartHandler {
    constructor() {
        document.addEventListener('click', (e) => {
            if (e.target.closest('button.bold_clone')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                this.beginAtc();
            }
        }, !0);
        console.log('Bold Custom Add To Cart Handler - Fix file upload: loaded');
    }

    beginAtc() {
        // Validate options
        BOLD.options.app.optionProducts[0].addToCartHandler.getValidationResults()
            .then(() => { // Validation pass
                this.addToCart(BOLD.options.app.optionProducts[0].element);
            })
            .catch(() => { // Validation fail
                console.warn('Missing required option');
                BOLD.options.app.optionProducts[0].element.scrollIntoView({
                    block: "center"
                })
            })
    }

    addToCart(boldRef) {
        const productForm = boldRef.closest('form');
        const formdata = new FormData(productForm);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formdata,
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else console.error('ATC failed');
            })
            .then(res => {
                console.log('Fetch res: ', res);
                BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
                this.completeThemeAtcFlow();
            })
    }

    completeThemeAtcFlow() {

        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                //console.log('Completing theme add to cart flow with cart: ', cart);
                let fixedCart = window.BOLD.common.cartDoctor.fix(cart);
                //console.log('The doctor has fixed the cart: ', fixedCart);
                window.theme.cart.setCurrentData(fixedCart);
                window.theme.cart.updateCart();
                window.theme.cart.showPopup();
            })
    }
}


document.addEventListener('DOMContentLoaded', function () {
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
        const isBoldFileUpload = !!document.querySelector('.bold_option_set input[type="file"]');
        if (isBoldFileUpload) {
            new BoldCustomAddToCartHandler();
        }
    })
})